import { render } from "./plus-circle.vue?vue&type=template&id=2ce782fc"
const script = {}

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak-fr1/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__